import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { Resource } from '../../../../store/ResourcesListStore';
import { CalendarsState, getEntityCalendar } from '../../../../store/CalendarsListStore';
import { Dictionary, EntityType, mapServerEntityType } from '../../../../entities/common';
import { getDefaultCostRateTable } from '../../../../store/selectors/costRateTableSelectors';
import { ViewType } from '../ResourceUsageGrid';
import { assignmentTimeTypesConfigMap, ProjectAssignments } from '../assignments';
import { TimeType } from './common';
import { calculateAssignmentsSummary } from './assignmentsSummary';
import { TotalCellValues, toTotalHours } from './TotalCell';

interface StateProps {
    calendars: CalendarsState;
    resourcePlanningLevel: EntityType;
    defaultCostRateTableId?: string;
}
interface OwnProps {
    resources: Resource[];
    assignments: Dictionary<ProjectAssignments> | undefined;
    entityType: EntityType;
    startDate: Date;
    finishDate: Date;
    timeType: TimeType[];
    viewType: ViewType;
}

type Props = StateProps & OwnProps;

const AssignmentsTotalCell = (props: Props) => {
    const { resources, assignments, startDate, finishDate, timeType, viewType, calendars, ...context } = props;
    const hours = toTotalHours(resources.map(resource => {
        const calendar = getEntityCalendar(calendars, resource, resource.calendar.id);
        const summary = calculateAssignmentsSummary(startDate, finishDate, { ...context, resource, calendar }, assignments?.[resource.id]?.byDay);
        return {
            plan: summary.effort,
            actual: summary.completedWork,
            remaining: summary.remainingWork,
            capacity: summary.capacityHours,
            availability: summary.availability,
            fullFteCapacityHours: summary.fullFteCapacityHours
        };
    }));

    return <TotalCellValues hours={hours} timeType={timeType} viewType={viewType} timeTypesConfig={assignmentTimeTypesConfigMap} />;
}

function mapStateToProps(state: ApplicationState, ownProps: OwnProps): StateProps {
    return {
        calendars: state.calendars,
        resourcePlanningLevel: mapServerEntityType[state.tenant.resourcePlanningSettings?.resourcePlanningLevel!]!,
        defaultCostRateTableId: getDefaultCostRateTable(state)?.id,
    };
}

export default connect(mapStateToProps)(AssignmentsTotalCell);
